module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-4-7e97f303fec6914d3f97d4d6828bad21.jpg";